const Contect = () => {
  return (
    <>
      <h1>contect us</h1>
    </>
  );
};

export default Contect;
